export const LOADER_STATUS = 'LOADER_STATUS';
export const COMPANIES_DATA = 'COMPANIES_DATA';
export const TOTAL_RECORD = 'boilerplate/company/TOTAL_RECORD'
export const GET_ALL_GROUPS = 'boilerplate/company/GET_ALL_GROUPS';
export const DEPARTMENT_LIST = 'boilerplate/company/DEPARTMENT_LIST'
export const REGION_LIST = 'boilerplate/company/REGION_LIST';


